// extracted by mini-css-extract-plugin
export default {"labelVerde":"VerAnalisisFQComponent_labelVerde__mUF-3"};